module.exports = __webpack_public_path__ + "2bbb00630ca3a333c45d075db1d3de7a.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/RoundedMplus1c-ExtraBold.ttf
// module id = 27
// module chunks = 0